export const AGENCY_ROLE_LABELS = {
  agency_admin: "Agency Admin",
  booking_staff: "Booking Staff",
  accountant: "Accountant",
};

const KNOWN_ROLES = new Set(["agency_admin", "booking_staff", "accountant"]);

function normalizeRoleValue(value) {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  if (normalized === "admin" || normalized === "agencyadmin") {
    return "agency_admin";
  }
  if (normalized === "staff" || normalized === "bookingstaff") {
    return "booking_staff";
  }
  if (normalized === "accounts" || normalized === "finance") {
    return "accountant";
  }
  return KNOWN_ROLES.has(normalized) ? normalized : normalized;
}

export function getAgencyRole(profile) {
  return normalizeRoleValue(profile?.agency_role || profile?.agencyRole || "agency_admin") || "agency_admin";
}

export function roleFromProfile(profile) {
  return profile ? getAgencyRole(profile) : "";
}

export function formatAgencyRole(profileOrRole) {
  const role = typeof profileOrRole === "string"
    ? getAgencyRole({ agency_role: profileOrRole })
    : getAgencyRole(profileOrRole);
  return AGENCY_ROLE_LABELS[role] || "Agency Admin";
}

export function isAgencyStaffUser(profile) {
  if (profile?.agency_user_id) {
    return true;
  }
  const role = getAgencyRole(profile);
  return role === "booking_staff" || role === "accountant";
}

export function canAccessFinance(role) {
  const agencyRole = normalizeRoleValue(role);
  return Boolean(agencyRole) && agencyRole !== "booking_staff";
}

export function canManageUsers(role) {
  return normalizeRoleValue(role) === "agency_admin";
}

export function canUpdateKyc(role) {
  return canManageUsers(role);
}

export function canWriteBookings(role) {
  const agencyRole = normalizeRoleValue(role);
  return agencyRole === "agency_admin" || agencyRole === "booking_staff";
}

export function canWritePassengers(role) {
  return canWriteBookings(role);
}

export function canWriteDocuments(role) {
  return canWriteBookings(role);
}

export function canAccessSupport(role) {
  return canWriteBookings(role);
}

export function canAccessPath(pathname, role) {
  const path = String(pathname || "").replace(/\/+$/, "") || "/";
  if (path === "/users") {
    return canManageUsers(role);
  }
  if (path === "/support" || path.startsWith("/support/")) {
    return canAccessSupport(role);
  }
  if (path === "/wallet-credit" || path === "/payment-proof") {
    return canAccessFinance(role);
  }
  if (path.endsWith("/book")) {
    return canWriteBookings(role);
  }
  return true;
}

export function filterMenuSections(sections, role) {
  const agencyRole = normalizeRoleValue(role);
  return (sections || [])
    .map((section) => {
      const items = (section.items || []).filter((item) => canAccessPath(item.path, agencyRole));
      if (section.type === "dropdown") {
        return { ...section, items };
      }
      if (!items.length && !section.type) {
        return null;
      }
      return { ...section, items };
    })
    .filter(Boolean);
}
